export interface GoogleLocationData {
  place_id: string;
  address_components: {
    long_name: string;
    short_name: string;
    types: string[];
  }[];
  formatted_address: string;
  geometry: {
    location: {
      lat: string;
      lng: string;
    };
    location_type: string;
    viewport: {
      northeast: {
        lat: string;
        lng: string;
      };
      southwest: {
        lat: string;
        lng: string;
      };
    };
  };
  postcode_localities: string[];
  plus_code: { compound_code: string; global_code: string };
  types: string[];
}
